/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useContext,useState,useRef ,useEffect} from 'react';
import GlobalContext from '../../Context/GloablContext';
import { Link, useLocation} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AnimatedModel from '../../Animation/AnimatedModel';
import { AnimatePresence } from 'framer-motion';
import ConfirmationPrompt from '../../ConfirmationPrompt';
import { Auth } from 'aws-amplify';
import {motion} from 'framer-motion'
import { useNavigate } from 'react-router-dom';
import { userService } from '../../../services/user.services';
import { organizationusersList } from '../../../slices/apiSlice';
import { setPatientSearch,resetPatientSearch } from '../../../redux/patientSearchSlice';
import { resetDeviceAlertSearch } from '../../../redux/deviceAlertReportSearchSlice';
import { resetAlertNotificationSearch } from '../../../redux/alerAndNotificationSearchSlice';
import { resetDeviceAlertDashboardSearch } from '../../../redux/deviceAleartDashboardSlice';
import { resetDashboardSearch } from '../../../redux/dashboardSearchSlice';
import { clearAuthSession, broadcastLogout } from '../../../CommonMethods/authSession';
import { logout } from '../../../pages/auth/authSlice';


const SideNavBar = ({role}) => {
    const location=useLocation()
    const {state}=useLocation()
    const [logOutOpen, setLogOutOpen] = useState(false);

    const [logoutLoading, setLogoutLoading] = useState(false)
    const [isAnimating,setIsAnimating]=useState(false)
    const navigate=useNavigate()
    const auth=useSelector(state=>state.auth)
    const firstName=sessionStorage.getItem('first_name');
    const lastName=sessionStorage.getItem('last_name');
    const userType = sessionStorage.getItem('user_type');
    const sidebar1Objs=(userType==="provider")?['Manage Patients','Alerts/Notifications','Upload File']:['Dashboard','Manage Patients','Upload File']
    // Filter out 'Manage Organization Users' if the user is not an admin
    const modifiedSidebar1Objs = (userType==="provider")||(userType==="monitor-user")
        ? sidebar1Objs
        : sidebar1Objs.filter(item => item !== 'Manage Organization Users');
    const linksTo1=(userType==="provider")?['/manage-patients','/alerts-notifications','/upload-file']:['/manage-dashboard','/manage-patients','/upload-file']
    const images=(userType==="provider")?['/images/manage_patients_default.svg','/images/bell-default.svg','/images/uploadFile_default.svg']:['/images/manage_organization_default.svg','/images/manage_patients_default.svg','/images/uploadFile_default.svg']
    /* Using the useContext hook to access the state variables `isSideNavBar` and `setIsSideNavBar`
    from the `GlobalContext` context. These variables are likely used to control the visibility and
    behavior of a side navigation bar in the UI. */


    const {isSideBar, setIsSideBar,show, setshow,setToastmessage,setToastErrorMessage,setRestrictKey,restrictKey,isOpen,setIsOpen, setIsSearchOpen, editSocket} = useContext(GlobalContext);
    const restrictSidebar = useSelector(state=>state?.systemConfigData?.restrict)
    /**
     * This function toggles the state of a side navigation bar.
     */
    const dispatch=useDispatch()
    const handleLogout= async ()=>{
        setLogoutLoading(true)
        const localLogoutAt = Date.now();
        localStorage.setItem('localLogoutAt', localLogoutAt.toString());
        localStorage.setItem('localLogoutInProgress', 'true');
        
        // Set logout flag to prevent WebSocket reconnection
        if (window.isLoggingOutRef) {
            window.isLoggingOutRef.current = true;
        }
        
        // Close WebSocket connections and remove handlers
        if (editSocket && (editSocket.readyState === 1 || editSocket.readyState === 0)) {
            editSocket.onmessage = null; // Remove message handler
            editSocket.onclose = null; // Prevent reconnection
            editSocket.close();
        }
        if (window.websocket && (window.websocket.readyState === 1 || window.websocket.readyState === 0)) {
            window.websocket.onmessage = null; // Remove message handler
            window.websocket.onclose = null; // Prevent reconnection
            window.websocket.close();
        }
        
        try {
            const logoutResponse = await userService.logout()
            
            // Clear showLogoutToast flag before broadcasting
            // This ensures the initiating tab doesn't show the cross-tab logout toast
            localStorage.removeItem('showLogoutToast');
            
            clearAuthSession();
            broadcastLogout();
            dispatch(logout());
            dispatch(organizationusersList.util.resetApiState())        
            setToastmessage(logoutResponse.error === false ? logoutResponse.data.message : 'Logout successful') 
            setIsSearchOpen(false)
            dispatch(resetPatientSearch()) 
            dispatch(resetDeviceAlertSearch()) 
            dispatch(resetDeviceAlertDashboardSearch())
            dispatch(resetDashboardSearch())
            dispatch(resetAlertNotificationSearch())
            navigate('/')
        } catch (error) {
            // Clear showLogoutToast flag before broadcasting
            localStorage.removeItem('showLogoutToast');
            
            clearAuthSession();
            broadcastLogout();
            dispatch(logout());
            dispatch(organizationusersList.util.resetApiState())        
            setToastmessage('Logout successful')  
            setIsSearchOpen(false)
            dispatch(resetPatientSearch())
            dispatch(resetDeviceAlertSearch()) 
            dispatch(resetDeviceAlertDashboardSearch())
            dispatch(resetDashboardSearch())
            dispatch(resetAlertNotificationSearch())
            navigate('/')
        } finally {
            setLogoutLoading(false)
            setLogOutOpen(false)
            localStorage.removeItem('localLogoutInProgress');
        }
    }
    
    const ref = useRef();

    const handleClickSideNavBar = () => {
        setIsSideBar(!isSideBar);
    }

    useEffect(()=>{
        if(restrictSidebar === "true" || restrictSidebar === true) {
            setIsSideBar(true)
        }
        // else{
        //     setIsSideBar(false)
        // }
    },[restrictSidebar])

    const handleOnClickSidenav = () =>{   
        dispatch(resetPatientSearch()); 
        dispatch(resetAlertNotificationSearch())
        dispatch(resetDeviceAlertDashboardSearch())
        dispatch(resetDashboardSearch());
        setIsSearchOpen(false)    
        dispatch(organizationusersList.util.resetApiState())                
    }

    return (
        <AnimatePresence>
            {!isSideBar ?
                <div className='flex top-0 left-0 min-w-[256px] w-[256px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] z-[99] bg-[#fff] opened_sidebar'>
                    <div className='w-full p-4'>
                        {isAnimating?<motion.div 
                            // animate={{ x: 0 }}
                            // initial={{ x: -10 }}
                            // transition={{duration:0.5}}
                        >
                            < div className='flex items-center pb-4 relative cursor-pointer'>
                                <Link to={'/profile'}  >
                                    <motion.div
                                        initial={{ opacity: 0, scale: 0.6 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.3,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01],
                                        }}>
                                        <div title="profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                            <p className='text-[#972E4C] font-semibold text-lg uppercase'>
                                                {lastName?.charAt(0) || ''}{firstName?.charAt(0) || ''}
                                            </p>
                                        </div>
                                    </motion.div>
                                </Link>
                            
                                <div className='pl-3'>
                                    <p id='provider' className='text-f1 uppercase font-medium text-[#757575]'>
                                        {userType === 'monitor-user' ? 'Monitor' : 'Provider'}
                                    </p>
                                    <p className='text-sm capitalize font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button id="menu"  className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>
                        </motion.div>:<>
                            <div className='flex items-center pb-4 relative'>
                                <Link to={'/profile'}>
                                    <div title="profile" className='w-11 h-11 bg-[#E7CBD2] rounded-[50%] enlarge-image transform hover:scale-120 flex justify-center items-center'>
                                        <p className='text-[#972E4C] font-semibold text-lg uppercase'>
                                            {lastName?.charAt(0) || ''}{firstName?.charAt(0) || ''}
                                        </p>
                                    </div>
                                </Link>
                               
                                <div className='pl-3'>
                                    <p id='provider' className='text-f1 uppercase font-medium text-[#757575]'>
                                        {userType === 'monitor-user' ? 'Monitor' : 'Provider'}
                                    </p>
                                    <p className='text-sm capitalize font-medium text-black'>{`${lastName} ${firstName}`}</p>
                                </div>
                                {/* onMouseEnter={()=>setIsSideBar(false)} onMouseLeave={()=>setIsSideBar(true)} */}
                                <button id="menu" disabled={restrictSidebar === true || restrictSidebar === "true"} className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-2 right-[-29px] bg-white' onClick={handleClickSideNavBar}>
                                    <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon" className='rotate-180'/>
                                </button>
                            </div>
                        </>}
                        <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>
                        <ul className='h-customh1 overflow-auto scrollbar_purple'>
                            {modifiedSidebar1Objs?.map((element,index)=>(
                                isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    key={index}
                                    className={`text-f1 font-medium mb-2`}>
                                    <li >
                                        {location.pathname!==linksTo1[index]||location.hash==="#report"?<Link  to={linksTo1[index]}  className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&!(location?.hash==="#report")?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                            
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </Link>:<div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        
                                            <motion.img  
                                                initial={{ opacity: 0, scale: 0.6 }}
                                                animate={{ opacity: 1, scale: 1 }}
                                                transition={{
                                                    duration: 0.3,
                                                    delay: 0.5,
                                                    ease: [0, 0.71, 0.2, 1.01],
                                                }}
                                            
                                                loading="lazy" decoding="async" src={images[index]} style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                            <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                        </div>}
                                    </li>
                                </motion.div>: <li key={index+"1"}>
                                    {location.pathname!==linksTo1[index]||location.hash==="#report"?<Link onClick={()=>{handleOnClickSidenav()}} key={index+"5"} to={linksTo1[index]} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </Link>:<div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50':""}`}> 
                                        <img
                                            loading="lazy" decoding="async" style={location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src={images[index]}  alt="icon"  />
                                        <p className={`pl-3 text-xs font-semibold ${location.pathname.includes(linksTo1[index])&&!logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'}`}>{element}</p>
                                    </div>}
                                </li>
                            ))}
                         
                            {isAnimating?<motion.div 
                                animate={{ x: 0 }}
                                initial={{ x: -10 }}
                                transition={{duration:0.5}}
                                exit={{y:-10}}
                                className={`text-f1 font-medium mb-2`}>
                                <li>
                                    <div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <Link to={location.pathname+location.search+'#report'} onClick={()=>{setIsOpen(!isOpen)}} className='flex justify-between items-center w-full'>
                                            <div className='flex items-center'>
                                                <motion.img  
                                                    initial={{ opacity: 0, scale: 0.6 }}
                                                    animate={{ opacity: 1, scale: 1 }}
                                                    transition={{
                                                        duration: 0.3,
                                                        delay: 0.5,
                                                        ease: [0, 0.71, 0.2, 1.01],
                                                    }}
                                                    loading="lazy" decoding="async" src={"/images/Reports_default.svg"}  style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                                {/* <img src="images/Reports_default.svg" alt="icon" /> */}
                                                <p className={`pl-3 text-xs font-semibold ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`} >Reports</p>
                                            </div>
                                            <span>
                                                <img loading="lazy" decoding="async" className={`${(isOpen)?"transform rotate-180" : ""}`} style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} src="/images/dropdown_icon.svg" alt="icon" />
                                            </span>
                                        </Link>
                                    </div>
                                    {(isOpen)&&<motion.div 
                                        // animate={{ x: 0,y:0 }}
                                        // initial={{ y: -10 }}
                                        // transition={{duration:0.2}}
                                        
                                        className={`text-f1 font-medium mb-2`}><div className='pl-5'>
                                        
                                            <Link key={'alert-report'} to={'/reports/alert-report'} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg `}>
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/alert-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Alert Reports</p></Link>
                                            <Link key={'wellness-report'} to={'/reports/wellness-report'} className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}>
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/wellness-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Wellness Reports</p></Link>
                                        </div></motion.div>}
                                </li>
                            </motion.div>:<>
                                <li>
                                    <div className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg cursor-pointer ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'bg-[#972E4C] bg-opacity-50':""}`}>
                                        <Link  to={location.pathname+location.search+'#report'} onClick={()=>{setIsOpen(!isOpen)}} className={`flex justify-between items-center w-full`}>
                                            <div className='flex items-center'>
                                                <img
                                                    loading="lazy" decoding="async" src={"/images/Reports_default.svg"} style={(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}  alt="icon" />
                                                {/* <img src="images/Reports_default.svg" alt="icon" /> */}
                                                <p className={`pl-3 text-xs font-semibold ${(location.pathname.includes('reports')||location.hash==="#report")&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Reports</p>
                                            </div>
                                            <span>
                                                <img src="/images/dropdown_icon.svg"  alt="icon" className={`${(isOpen)?"transform rotate-180" : ""}`} style={((isOpen)||location.pathname.includes('reports'))&&!logOutOpen?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} />
                                            </span>
                                        </Link>
                                    </div>
                                    {(isOpen)&&<motion.div 
                                        animate={{ x: 0,y:0 }}
                                        initial={{ y: 0 }}
                                        transition={{duration:0.2}}
                                        
                                        className={`text-f1 font-medium mb-2`}>
                                        <div className='pl-5'>
                                            <Link
                                                onClick={(e) => {
                                                    if (location.pathname.includes('reports/alert-report')) {
                                                        e.preventDefault(); // Prevent navigation if already on the same tab
                                                        return;
                                                    }
                                                    handleOnClickSidenav(); // Call the function if navigating to a different tab
                                                }}
                                                key={'alert-report'}
                                                to={'/reports/alert-report'}
                                                className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}
                                            >
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/alert-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Alert Reports</p></Link>
                                            <Link 
                                                onClick={(e) => {
                                                    if (location.pathname.includes('reports/wellness-report')) {
                                                        e.preventDefault(); // Prevent navigation if already on the same tab
                                                        return;
                                                    }
                                                    handleOnClickSidenav(); // Call the function if navigating to a different tab
                                                }}
                                                key={'wellness-report'} 
                                                to={'/reports/wellness-report'} 
                                                className={`px-3 py-2.5 w-full flex items-center mb-2 rounded-lg`}
                                            >
                                                <p className={`pl-3 text-xs font-semibold ${location.pathname.includes('reports/wellness-report')&&!logOutOpen?'text-[#972E4C] ':'text-[#52555D]'}`}>Wellness Reports</p></Link>
                                        </div></motion.div>}
                                </li>
                            </>}
                        </ul>
                        <div className='h-[2px] bg-[#C5C9DA] rounded-sm mb-4'></div>
                        <ul className=''>
                            <li>
                                {isAnimating?<motion.div 
                                    animate={{ x: 0 }}
                                    initial={{ x: -10 }}
                                    transition={{duration:0.5}}
                                    className={`text-f1 font-medium mb-2`} key="logout">
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen&&location?.hash===""?'bg-[#972E4C] bg-opacity-50 ':''}`}  onClick={()=>{setLogOutOpen(true)}}>
                                        <motion.img  
                                            initial={{ opacity: 0, scale: 0.6 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            transition={{
                                                duration: 0.3,
                                                delay: 0.5,
                                                ease: [0, 0.71, 0.2, 1.01],
                                            }}
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"}  alt="icon"  style={logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}}/>
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </motion.div>:<>
                                    <button id="logout" className={`px-3 py-2.5 w-full flex items-center rounded-lg ${logOutOpen?'bg-[#972E4C] bg-opacity-50':''}`} onClick={()=>{setLogOutOpen(true)}}>
                                        <img
                                            loading="lazy" decoding="async" src={"/images/Log-out.svg"} style={logOutOpen&&location?.hash===""?{filter:"grayscale(56%) saturate(2023%) contrast(91%) hue-rotate(1194deg)"}:{}} alt="icon" />
                                        <p className={`pl-3 text-xs font-semibold ${logOutOpen&&location?.hash===""?'text-[#972E4C] ':'text-[#52555D]'} `} >Logout</p>
                                    </button>
                                </>}
                            </li>
                 
                        </ul>
                    </div>
                </div>
                :
                <div className='flxed top-0 left-0 min-w-[30px] w-[30px] shadow-s2 h-screen rounded-tr-[12px] rounded-br-[12px] border-r border-[#0000001A] relative z-[99] bg-[#fff] closed_sidebar'>
                    <button 
                        id="menu"
                        disabled={restrictSidebar === true || restrictSidebar === "true"}                        
                        onClick={handleClickSideNavBar} 
                        className='p-1.5 border border-[#F6F6F6] rounded-lg shadow-s2 pl-1 absolute top-5 right-[-12px] bg-white' 
                    >
                        <img loading='lazy' decoding='async' src="/images/menu_slider.svg" alt="menu-icon"/>
                    </button>
                </div>
            }
        
            {logOutOpen && 
            <AnimatedModel key="logout-model"
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleLogout}
                        handleClose={() => setLogOutOpen(false)}
                        tittle= {`Logout`}
                        message = {`Are you sure you want to logout?`}
                        buttonName = {`Logout`}
                        disabled={logoutLoading}
                        loadingActivation={logoutLoading}
                    />
                }
            />  
            }
        </AnimatePresence>
    );
}
const memoisedComponent=React.memo(SideNavBar)
export default memoisedComponent
